import Login from "views/Auth/Login"
import Register from "views/Auth/Register"
import ForgotPassword from "views/Auth/ForgotPassword"
import ResetPassword from "views/Auth/ResetPassword"

export const authRouteData = [
    {
        element: <Login />,
        url: "/login"
    },
    {
        element: <Register />,
        url: "/register"
    },
    {
        element: <ForgotPassword />,
        url: "/forgot-password"
    },
    {
        element: <ResetPassword />,
        url: "/reset-password"
    }
]